<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/label/releases"
        :defaultOpenPanelsArray="[]" 
    >
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-title'">
            {{ data.name ? data.name : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED')}}
            </div>
        </template>
        <template v-slot:editForm="{ data }">
            <v-col cols="2">
                <v-row>
                     <v-col>
                        <v-img v-if="data.cover" :src="data.cover" aspect-ratio="1"></v-img>
                        <v-img v-else
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >                                
                                {{ $t('lang_LABEL_RELEASES') }}
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
               
            </v-col>

            <v-col cols="3">
                 <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_TITLE')"
                        :context="context"
                        field="ReleaseTitle"
                        rules="required"
                        :alvqa="alvqa + '-textfield-release-title'"
                    />
                </v-row>
                 <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_ALTERNATIVE_TITLE')"
                        :context="context"
                        field="AlternativeTitle"
                        :alvqa="alvqa + '-textfield-alternative-title'"
                    />
                </v-row>
                <!-- <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_CAPTION_FIRST_MAIN_ARTIST')" 
                        field="Artist"
                        :context="context"
                        rules="required"
                        :alvqa="alvqa + '-textfield-artist'"
                    />
                </v-row> -->
                <v-row>
                    <v-col class="pa-0 ma-0" cols="10">
                        <BaseReadOnlyTextField
                            :innerValue="getAzName"
                            :label="$t('lang_LABEL_RELEASES_CAPTION_ARTIST')"
                            :alvqa="alvqa + '-textfield-interpret'"
                            rules="isReleaseArtistObject"
                            :iconTooltipText="$t('lang_LABEL_CAPTION_TOOLTIP_ARTIST_TYPE') + (data.performer && data.performer.alvId ? ' [' + data.performer.alvId + ']' : '')"                        />
                    </v-col>
                    <v-col class="justify-end d-flex ml-0 pl-0" cols="2">
                        <BaseIcon   
                            :alvqa="alvqa + '-icon-edit-interpret-connection'"
                            :icon="isArtistConnected ? 'delete' : 'edit'" 
                            :tooltipText="isArtistConnected ? 'lang_GENERIC_CAPTION_DELETE' : 'lang_GENERAL_CAPTION_ICON_EDIT'"   
                            @click="editConnectedArtist()"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_GEMA_TYPE')" 
                        :items="getGemaTypeItems" 
                        :context="context"
                        field="SelectedGemaTypeId"
                        :alvqa="alvqa + '-dropdown-gema-types'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_MEDIA_TYPE')" 
                        :items="getMediaTypeItems" 
                        :context="context"
                        rules="required"
                        field="SelectedMediaTypeId"
                        :alvqa="alvqa + '-dropdown-media-types'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_GENRE_1')" 
                        :items="getGenreItems" 
                        :context="context"
                        field="SelectedGenre1Id"
                        :alvqa="alvqa + '-dropdown-genres-1'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_GENRE_2')" 
                        :items="getGenreItems" 
                        :context="context"
                        field="SelectedGenre2Id"
                        :alvqa="alvqa + '-dropdown-genres-2'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_GENRE_3')" 
                        :items="getGenreItems" 
                        :context="context"
                        field="SelectedGenre3Id"
                        :alvqa="alvqa + '-dropdown-genres-3'"
                    />                    
                </v-row>                
                <v-row> 
                    <BaseEditPageTextarea 
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"  
                        field="Notes"
                        rows="3"
                        :context="context"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>

            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_EAN_UPC')" 
                        field="EanUpc"
                        :context="context"
                        :alvqa="alvqa + '-textfield-ean'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_CATALOGUE_NUMBER')" 
                        field="CatalogueNumber"
                        :context="context"
                        :alvqa="alvqa + '-textfield-catalogue-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_OTHER_ID')" 
                        field="OtherId"
                        :context="context"
                        :alvqa="alvqa + '-textfield-other-id'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_GEMA_CATALOGUE_NO')" 
                        field="GemaCatalogueNumber"
                        :context="context"
                        :alvqa="alvqa + '-textfield-gema-catalogue-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_GEMA_REG_NO')" 
                        field="GemaRegistrationNumber"
                        :context="context"
                        :alvqa="alvqa + '-textfield-gema-registration-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_GEMA_LTN_NUMBER')" 
                        field="GemaLtnNumber"
                        :context="context"
                        :alvqa="alvqa + '-textfield-gema-ltn-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_C_NOTICE')" 
                        field="CNotice"
                        :context="context"
                        :alvqa="alvqa + '-textfield-c-notice'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_P_NOTICE')" 
                        field="PNotice"
                        :context="context"
                        :alvqa="alvqa + '-textfield-p-notice'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_TAGS')"  
                        field="Tags"
                        :context="context"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row>
            </v-col>

            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_MINIMUM_STOCK')" 
                        field="MinimumStock"
                        :context="context"
                        :type="'number'"
                        rules="integer"
                        :alvqa="alvqa + '-textfield-minimum-stock'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_DISCS')" 
                        :items="getNumberOfDiscsItems" 
                        :context="context"
                        :clearable="false"
                        field="SelectedNumberOfDiscs"
                        :alvqa="alvqa + '-dropdown-number-of-discs'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_VOLUME')" 
                        field="Volume"
                        :context="context"
                        :alvqa="alvqa + '-textfield-volume'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_LABEL_RELEASE_CAPTION_WEIGHT')" 
                        field="Weight"
                        :context="context"
                        :type="'number'"
                        rules="integer"
                        :alvqa="alvqa + '-textfield-weight'"
                    />
                </v-row>
                <!-- HS Code -->
                <v-row>
                    <BaseEditPageTextField 
                        :label="$t('lang_ERP_SHIPPING_CAPTION_HS_CODE')" 
                        field="HsCode"
                        :context="context"
                        :type="'number'"
                        rules="integer"
                        :alvqa="alvqa + '-textfield-hscode'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_COUNTRY_OF_ORIGIN')" 
                        field="CountryOfOrigin"
                        :items="countries"
                        :context="context"
                        :alvqa="alvqa + '-dropdown-country-of-origin'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="DatePhysical"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL')"
                        :alvqa="alvqa + '-datepicker-physical-date'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="DateDigital"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL')"
                        :alvqa="alvqa + '-datepicker-digital-date'"
                    />
                </v-row>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="DatePrerelease"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DATE_PRERELEASE')"
                        :alvqa="alvqa + '-datepicker-prerelease-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Conductor"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_CONDUCTOR')"
                        :alvqa="alvqa + '-textfield-conductor'"
                    />                            
                </v-row>          
                <v-row> 
                    <BaseEditPageTextarea 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_MUSICIANS')"  
                        field="Musicians"
                        rows="3"
                        :context="context"
                        :alvqa="alvqa + '-textarea-musicians'"
                    />
                </v-row>
            </v-col>

            <v-col cols="2">
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_PRICE_CATEGORY')" 
                        :items="getPriceCatogoryItems" 
                        :context="context"
                        field="SelectedCategoryId"
                        :alvqa="alvqa + '-dropdown-price-category'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_GENERIC_CAPTION_PRICELIST')" 
                        :items="getReleasePricelists" 
                        :context="context"
                        field="SelectedReleasePricelists"
                        :alvqa="alvqa + '-dropdown-release-pricelists'"
                    />                    
                </v-row>
                
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_LANGUAGE')" 
                        :items="$alvPlugin.getListOfGenericMusicLanguages('label-releases')" 
                        :context="context"
                        field="SelectedLanguageId"
                        :alvqa="alvqa + '-dropdown-languages'"
                    />                    
                </v-row>

                
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="TracksNumber"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_TRACKS')"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-tracks-number'"
                    />                            
                </v-row> 

                
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CompilationTracks"
                        :label="$t('lang_LABEL_RELEASES_COMPILATIONS_TRACKS')"
                        :alvqa="alvqa + '-textfield-compilation-tracks'"
                    />                            
                </v-row>
                <v-row>
                    <!-- PT: field is disabled because we need to rework getLicensorsItems()
                    of type = Lizenznehmer, before data was sent on login wasting 
                    almost 10 seconds of login time, now down to 2 seconds 
                    see HS ticket: https://app.hubspot.com/contacts/19576964/ticket/416621677/  -->
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_LICENSOR')" 
                        :items="getLicensorsItems" 
                        :context="context"
                        field="SelectedLicensorId"
                        :disabled="true"
                        :alvqa="alvqa + '-dropdown-licensors'"
                    />                    
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_GEMA_TAS')"
                        :items="getDropdownYesNo"
                        :context="context"
                        :clearable="false"
                        field="SelectedGemaTasId"
                        :alvqa="alvqa + '-dropdown-gema-tas'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASE_LABEL')" 
                        :items="getLabelsItems" 
                        :clearable="false"        
                        :context="context"
                        rules="required"
                        field="SelectedLabelId"
                        :alvqa="alvqa + '-dropdown-label-company'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Favourite"
                        :items="getDropdownYesNo" 
                        :label="$t('lang_GENERAL_FAVOURITE')" 
                        :alvqa="alvqa + 'dropdown-favourite'"
                        :clearable="false"
                    />
                </v-row>
            </v-col>
        </template> 
        <template v-slot:panels>
            <DeletionDialog :useContextSetinVuex="true" />
            <ConnectArtistToReleaseDialog />

            <!-- TRACKS -->
            <ReleasesTracksEditPanel />
            <SearchDialog 
                context="LabelReleases"
                subcontext="Tracks" 
                searchcontext="LabelReleaseTrack"
                addcontext="TracksToRelease"
                addButtonLabel="lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_BUTTON_ADD_TRACKS"
                dialogTitle="lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TITLE"
                :uniqueIdRequired="true"
                :alvqaContext="alvqa"
            >
                <template v-slot:itemTitle="{ item }">
                    {{ item.title }} {{ item.isrc ? '(' + item.isrc + ')' : '' }}
                </template>

                <template v-slot:itemSubtitle="{ item }">
                    <span>{{ $alvPlugin.getArtistOrPerformerName(item.artist) }}</span>
                </template>

            </SearchDialog>

            <!-- ARTISTS -->
            <ReleasesArtistsEditPanel />
            <ReleasesArtistsEditPanelDialog />
            
            <!-- PROMOTIONAL TEXT -->
            <ReleasePromotionalTextsEditPanel />
            <ReleasePromotionalTextsEditPanelDialog />

            <!-- OTHER IDS -->
            <ReleasesOtherIdsEditPanel />
            <ReleasesOtherIdsEditPanelDialog />

            <!-- COSTS -->
            <ReleasesCostsEditPanel />
            <ReleasesCostsEditPanelDialog />
            <LabelReleasesCostsplittingDialog />

            <!-- BUDGET -->
            <ReleasesBudgetEditPanel />
            <ReleasesBudgetEditPanelDialog />

            <!-- DIGITAL DISTRIBUTION -->
            <ReleaseDigitalDistributionEditPanel />
            <ReleaseDigitalDistributionEditPanelDialog />
            
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'

import ReleasesArtistsEditPanel from './_panels/1_artists/ReleasesArtistsEditPanel'
import ReleasesTracksEditPanel from './_panels/2_tracks/ReleasesTracksEditPanel'
import ReleasePromotionalTextsEditPanel from './_panels/3_promotionalTexts/ReleasePromotionalTextsEditPanel'
import ReleaseDigitalDistributionEditPanel from './_panels/4_distribution/ReleaseDigitalDistributionEditPanel'
import ReleasesCostsEditPanel from './_panels/5_costs/ReleasesCostsEditPanel'
import ReleasesBudgetEditPanel from './_panels/6_budget/ReleasesBudgetEditPanel'
import ReleasesOtherIdsEditPanel from './_panels/7_otherids/ReleasesOtherIdsEditPanel'
import ReleasesOtherIdsEditPanelDialog from './_panels/7_otherids/ReleasesOtherIdsEditPanelDialog'

import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SearchDialog from '@/components/_dialogs/SearchDialog'
import EditingDialog from '@/components/_dialogs/EditingDialog'
import ReleaseDigitalDistributionEditPanelDialog from './_panels/4_distribution/ReleaseDigitalDistributionEditPanelDialog'
import ReleasesArtistsEditPanelDialog from './_panels/1_artists/ReleasesArtistsEditPanelDialog'
import ReleasePromotionalTextsEditPanelDialog from './_panels/3_promotionalTexts/ReleasePromotionalTextsEditPanelDialog'
import ReleasesCostsEditPanelDialog from './_panels/5_costs/ReleasesCostsEditPanelDialog'
import ReleasesBudgetEditPanelDialog from './_panels/6_budget/ReleasesBudgetEditPanelDialog'
import LabelReleasesCostsplittingDialog from './_panels/5_costs/LabelReleasesCostsplittingDialog'
import ConnectArtistToReleaseDialog from '../_dialogs/ConnectArtistToReleaseDialog'

import {    DropdownGeneralPriceCategories,
            DropdownLabelReleasesMediaTypes,
            DropdownGenericYesNo,
        } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: 'LabelReleasesEdit',
    data() {
        return {
            context: "LabelReleases",
            alvqa: "label-releases-edit-form"
        }
    },
    components: {
        BaseEditPage,
        BaseEditPageTextField,
        BaseButton,
        BaseIcon,
        BaseEditPageTextarea,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        BaseReadOnlyTextField,

        SearchDialog,
        DeletionDialog,
        EditingDialog,
        ReleaseDigitalDistributionEditPanelDialog,
        ReleasesArtistsEditPanelDialog,
        ReleasePromotionalTextsEditPanelDialog,
        ReleasesCostsEditPanelDialog,
        ReleasesBudgetEditPanelDialog,
        ReleasesOtherIdsEditPanelDialog,
        LabelReleasesCostsplittingDialog,
        ConnectArtistToReleaseDialog,

        ReleasesTracksEditPanel,
        ReleaseDigitalDistributionEditPanel,
        ReleasesArtistsEditPanel,
        ReleasePromotionalTextsEditPanel,
        ReleasesCostsEditPanel,
        ReleasesBudgetEditPanel,
        ReleasesOtherIdsEditPanel
    },
    computed: {
        // Dropdowns
        countries() { return this.$alvPlugin.getListOfTranslatedCountries() },
        getLabelsItems() { 
            this.$store.commit('setLabelCompanies')
            let labels = []
            let labelsDropdown = []
            this.$store.getters.getLabelCompanies.forEach((labelCompany) => {
                if(labelCompany.labels != null) {
                    labels = labels.concat(labelCompany.labels)
                }
            })

            labels.forEach((label) => {
                labelsDropdown.push({
                    "value": parseInt(label.id),
                    "text": label.name_alv + ' (' + label.alvId + ')',
                    "alvqa": this.alvqa + '-dropdown-label-company-' + label.id
                })
            })
            if(labelsDropdown === undefined || labelsDropdown.length === 0 || labelsDropdown.error === 1) labelsDropdown = []

            return labelsDropdown
        },
        getGemaTypeItems() { 
            let gemaTypesDb = this.$store.getters['getReleaseGemaMediaTypes']
            gemaTypesDb.forEach(type => {
                type['alvqa'] = this.alvqa + '-dropdown-gema-types-' + type.value
            });

            return gemaTypesDb
        },
        getMediaTypeItems() { 
            let mediaTypesDb = JSON.parse(JSON.stringify(DropdownLabelReleasesMediaTypes))
            
            // set alvqas
            mediaTypesDb.forEach(type => {
                type['alvqa'] = this.alvqa + '-dropdown-media-types-' + type.value
            });

            // create a new array with "disabled" information, a-z sorted and divider for seperate still used options and not anymore used.
            let topItems = []
            mediaTypesDb.forEach(element => {
                if(element['disabled'] === "1" || element['disabled'] === false) {
                    element['disabled'] = false
                    if(this.$alvPlugin.isLangConst(element['text'])) element['text'] = this.$i18n.t(element['text'])
                    topItems.push(element)
                }
            });

            topItems.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)

            // Divider
            topItems.push({ divider: true })

            let oldItems = []
            mediaTypesDb.forEach(element => {
                if(element['disabled'] === "0" || element['disabled'] === true) {
                     element['disabled'] = true
                     if(this.$alvPlugin.isLangConst(element['text'])) element['text'] = this.$i18n.t(element['text'])
                    oldItems.push(element)
                }
            });
            oldItems.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)
            topItems = topItems.concat(oldItems)

            return topItems
        },
        getGenreItems() { 
            let genresDb = this.$store.getters['getGenres' + this.$i18n.locale.toUpperCase()]
            // TODO_PT: not a solution => need to fix for Korean => genresDb is null
            if (genresDb) {
                genresDb.forEach(genre => {
                    genre['alvqa'] = this.alvqa + '-dropdown-genres-' + genre.value
                });
                return  genresDb
            } else {
                return []
            }
        },
        getNumberOfDiscsItems() {
            let items = []
            for(let i = 1; i <= 99; i++) {
                let text = i.toString()
                items.push(
                    {
                        text : text, 
                        value: i,
                        alvqa: this.alvqa + '-dropdown-number-of-discs-' + i
                    }
                )
            }

            return items
        },
        getPriceCatogoryItems() { return DropdownGeneralPriceCategories },
        getReleasePricelists()  { return this.$store.getters.getLabelReleasesPricelistsOptions },
        getLicensorsItems()     {
            let dropDown = [] 
            this.$store.getters['getLicensors'].forEach((licensor) => {
                dropDown.push({
                    value: licensor["id"],
                    text: licensor["name"],
                    alvqa: this.alvqa + '-dropdown-licensors-' + licensor["id"]
                })
            })

            return dropDown
        },
        getDropdownYesNo() { return DropdownGenericYesNo },
        getData() {
            return this.$store.getters['getLabelReleasesDetails']
        },
        isArtistConnected() { return this.getAzName !== null },
        getAzName() { return this.$store.getters.getLabelReleasesDetailsConnectedArtist },
        connectToAllTracksCheckbox: {
            get()       { return this.$store.getters.getLabelReleasesArtistForReleasesConnectToAllTracksCheckbox },
            set(value)  { this.$store.commit('setLabelReleasesArtistForReleasesConnectToAllTracksCheckbox', value) }
        },
    },
    methods: {
        tracksFoundSelectedText(tracks, selected) { //TODO Change LangConsts
            let text = tracks.length + ' '

            if(tracks.length === 0) {
                text += this.$t('lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TRACKS_FOUND')
                return text
            }

            if(tracks.length === 1) text += this.$t('lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TRACK_FOUND')
            else text += this.$t('lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TRACKS_FOUND')

            text += ', ' + selected.length + ' '

            if(selected.length === 1) text += this.$t('lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TRACK_SELECTED') 
            else text += this.$t('lang_LABEL_RELEASES_ADD_TRACKS_DIALOG_TRACKS_SELECTED') 
            
            return text
        },
        editConnectedArtist() {
            this.connectToAllTracksCheckbox = []
            if(this.isArtistConnected) this.$store.dispatch('deleteArtistLabelReleasConnection')
            else this.$store.commit('setShowConnectArtistDialog', true)
        }
    },
    created() {
        this.$store.dispatch('fetchLabelReleasesPricelistsDropdownValues')
        this.$store.commit('setCountries')
    }
}
</script>